import { render, staticRenderFns } from "./WebsiteSetting.vue?vue&type=template&id=be3ee340&"
import script from "./WebsiteSetting.vue?vue&type=script&lang=js&"
export * from "./WebsiteSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\manla\\Downloads\\b\\public_html\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be3ee340')) {
      api.createRecord('be3ee340', component.options)
    } else {
      api.reload('be3ee340', component.options)
    }
    module.hot.accept("./WebsiteSetting.vue?vue&type=template&id=be3ee340&", function () {
      api.rerender('be3ee340', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/WebsiteSetting.vue"
export default component.exports